import { render, staticRenderFns } from "./ActualizarReglaBMAT.vue?vue&type=template&id=1b7b5e32"
import script from "./ActualizarReglaBMAT.vue?vue&type=script&lang=js"
export * from "./ActualizarReglaBMAT.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports